<template>
  <div style="display: grid;">
    <div class="mb-2" style="margin-left: -24px;">
      <ul class="step-menu">
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Customer Information</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Consignee / Shipper</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Billing Information</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Required Documents</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">5</div>
          <div>Additional</div>
        </li>
      </ul>
    </div>
    <div class="scroller mt-4" style="margin-left: 16px;margin-right: 44px;">
      <div v-if="isLoadingDoc" class="_documents__container">
        <half-circle-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
        />
      </div>
      <table v-else class="table">
        <thead>
          <tr style="background: #ECF1F5;font-size: 14px;font-weight: 600;">
            <th scope="col">PIC Name / Uploader</th>
            <th scope="col">Document</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="document in documentsData" :key="document.name" style="height: 4rem;">
            <th style="font-size: 14px;">{{ document.uploader ? document.uploader : ''}}</th>
            <td style="font-size: 14px;">{{ document.title ? document.title : '-'}}</td>
            <td style="font-size: 14px;">{{ document.status ? 'Uploaded' : 'Not Uploaded'}}</td>
            <td class="text-left">
              <div v-if="!document.status">
                <button class="button__bluecorporite" @click.prevent="toUpload(document.name)">Upload</button>
              </div>
              <div v-else>
                <img
                @click.prevent="
                  downloadDoc(
                    document.name,
                    `${document.name}${document.status}`
                  )
                "
                class="status-icon"
                src="@/assets/image/icon/trash-detail.svg"
                alt=""
                height="20px"
                width="20px"
                style="line-height: 1.9;cursor: pointer;"
                />
                <img
                @click.prevent="
                  toReUpload(document.name, document.status)
                "
                class="status-icon ml-4"
                src="@/assets/image/icon/pencil-alt.svg"
                alt=""
                height="20px"
                width="20px"
                style="line-height: 1.9;cursor: pointer;"
                />
                <!-- <img
                class="status-icon ml-4"
                src="@/assets/image/icon/trash.svg"
                alt=""
                height="20px"
                width="20px"
                style="line-height: 1.9;cursor: pointer;"
                /> -->
              </div>         
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-end align-items-center mr-4">
      <button class="btn btn-white-blue mr-2" @click="onSelectedTabBack">Back</button>
      <div class="btn btn-white-blue mr-2" @click="saveDraft">Save Draft</div>
      <button class="btn btn-white-blue" @click="onSelectedTab">Next</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  name: 'form4',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      documentsData: []
    }
  },
  computed: {
    ...mapGetters({
      account: 'settingAccount/account',
      company: 'settingCompany/company',
      docs: 'settingDocs/docs',
      error: 'settingDocs/error',
      isLoadingDoc: 'settingDocs/isLoading',

      users: 'settingUsers/users',
      // eslint-disable-next-line no-dupe-keys
      error: 'settingUsers/error',
      // eslint-disable-next-line no-dupe-keys
      isLoading: 'settingUsers/isLoading'
    })
  },
  async mounted () {
    await this.fetchDocs()
    await this.fetchCompanyProfile()
    await this.fetchAccount()
    await this.fetchUsers()
  },
  watch: {
    docs (data) {
      this.initialData()
      if (data) {
        this.documentsData.forEach(doc => {
          if (doc.name === 'npwp') {
            doc.uploader = this.account.fullname
            doc.status = data.npwp
            doc.url = data.urlnpwp
          } else if (doc.name === 'nib') {
            doc.status = data.nib
            doc.url = data.urlnib
          } else if (doc.name === 'license') {
            doc.status = data.license
            doc.url = data.urllicense
          } else if (doc.name === 'ktp') {
            doc.status = data.ktp
            doc.url = data.urlktp
            doc.title = 'KTP'
          } else if (doc.name === 'passport') {
            doc.status = data.passport
            doc.url = data.urlpassport
            doc.title = 'Passport'
          } else if (doc.name === '') {
            doc.status = data.companyKind === 'CV' ? data.aoa : data.sppkp
            doc.name = data.companyKind === 'CV' ? 'aoa' : 'sppkp'
            doc.url = data.companyKind === 'CV' ? data.urlaoa : data.urlsppkp
            doc.title = data.companyKind === 'CV' ? 'Article of Association (Optional)' : 'SPPKP (Optional)'
          } else if (doc.name === 'siup') {
            doc.status = data.siup
            doc.url = data.urlsiup
          } else if (doc.name === 'taxletter') {
            doc.status = data.taxletter
            doc.url = data.urltaxletter
          } else if (doc.name === 'financial') {
            doc.status = data.financial
            doc.url = data.urlfinancial
          } else if (doc.name === 'skkemenkumham') {
            doc.status = data.skkemenkumham
            doc.url = data.urlskkemenkumham
          } else if (doc.name === 'taxletter') {
            doc.status = data.taxletter
            doc.url = data.urltaxletter
          } else if (doc.name === 'aoa') {
            doc.status = data.aoa
            doc.url = data.urlaoa
          } else if (doc.name === 'certificate') {
            doc.uploader = this.account.fullname
            doc.status = data.certificate
            doc.url = data.urlcertificate
          }
        })
      }
    }
  },
  methods: {
    async fetchDocs () {
      await this.$store.dispatch('settingDocs/FETCH_DOCS').then(() => {})
    },
    async fetchCompanyProfile () {
      await this.$store.dispatch('settingCompany/FETCH_COMPANY').then(() => {
        if (this.company) {
          this.companyStatusSAF = this.company.status
        }
      })
    },
    async fetchAccount () {
      await this.$store.dispatch('settingAccount/FETCH_ACCOUNT')
    },
    async fetchUsers () {
      await this.$store.dispatch('settingUsers/FETCH_USERS').then(() => {
        if (this.users) {
          this.usersData = this.users[0]
        }
      })
    },
    initialData () {
      if (this.account.countryName === 'Indonesia') {
        this.documentsData = [
          {
            name: 'npwp',
            title: 'NPWP Company',
            status: false,
            url: '',
            uploader: 'Aditya'
          },
          {
            name: 'nib',
            title: 'NIB',
            status: false,
            url: ''
          },
          {
            name: 'license',
            title: 'Business License',
            status: false,
            url: ''
          },
          {
            name: this.docs.ktp ? 'ktp' : 'passport',
            title: '',
            status: false,
            url: ''
          },
          {
            name: '',
            title: '',
            status: false,
            url: ''
          },
          {
            name: 'siup',
            title: 'SIUP (optional)',
            status: false,
            url: ''
          },
          {
            name: 'taxletter',
            title: 'Tax exemption letter (Optional)',
            status: false,
            url: ''
          },
          {
            name: 'financial',
            title: 'Financial stantment (Optional)',
            status: false,
            url: ''
          },
          {
            name: 'skkemenkumham',
            title: 'SK Kemenkumham (Optional)',
            status: false,
            url: ''
          }
        ]
      } else {
        this.documentsData = [
          {
            name: 'certificate',
            title: 'Incorporation Certificate',
            status: false,
            uploader: 'Aditya'
          },
          { name: 'license',
            title: 'Business License',
            status: false,
            url: '' 
          },
          { name: 'aoa',
            title: 'Article of Association (Optional)',
            status: false,
            url: '' 
          },
          { name: 'taxletter',
            title: 'Tax Exemption Letter (Optional)',
            status: false,
            url: '' 
          },
          { name: 'financial', title: 'Financial Statements (Optional)', status: false, url: '' }
        ]
      }
    },
    toUpload (type, status) {
      const payload = {
        type: type,
        status: status
      }
      this.$eventHub.$emit('dialog-modal-document', payload)
    },
    toReUpload (type, status) {
      const payload = {
        type: type,
        status: status
      }
      this.$eventHub.$emit('dialog-confirmation-reupload', payload)
    },
    async downloadDoc (type, name) {
      await this.$store.dispatch('settingDocs/DOWNLOAD_DOCS', {
        type: type,
        fileName: name
      })
    },
    onSelectedTab () {
      this.$emit('Next', 'form5')
    },
    onSelectedTabBack () {
      this.$emit('Back', 'form3')
    },
    saveDraft () {
      this.$emit('Draft', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/saf/form4.vue